module.exports = __webpack_public_path__ + "static/img/btn-satisfaction-2-b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/btn-satisfaction-2-b.png
// module id = 519
// module chunks = 0